// Italian-locale formatters. Single source for the entire app (Rev 3 principle).
// Backend rejects locale-formatted strings on input — see feedback_carrier_mapping_safety.md.
// These helpers are for DISPLAY only. parseUserNumber is the inverse for user typed input.

const EUR = new Intl.NumberFormat('it-IT', {
  style: 'currency',
  currency: 'EUR',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

const DATE = new Intl.DateTimeFormat('it-IT', {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
});

const DATETIME = new Intl.DateTimeFormat('it-IT', {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
});

export function formatEuroFromCents(cents: number | null | undefined): string {
  if (cents === null || cents === undefined) return '—';
  return EUR.format(cents / 100);
}

export function formatEuro(amount: number | null | undefined): string {
  if (amount === null || amount === undefined) return '—';
  return EUR.format(amount);
}

export function formatDate(input: string | Date | null | undefined): string {
  if (!input) return '—';
  const d = input instanceof Date ? input : new Date(input);
  if (Number.isNaN(d.getTime())) return '—';
  return DATE.format(d);
}

export function formatDateTime(input: string | Date | null | undefined): string {
  if (!input) return '—';
  const d = input instanceof Date ? input : new Date(input);
  if (Number.isNaN(d.getTime())) return '—';
  return DATETIME.format(d);
}

/**
 * Parse a user-entered Italian-formatted number (e.g. "1.234,56") to a JS number.
 * Returns null if the input cannot be parsed.
 */
export function parseUserNumber(input: string): number | null {
  if (typeof input !== 'string') return null;
  const trimmed = input.trim();
  if (trimmed === '') return null;
  const normalized = trimmed.replace(/\./g, '').replace(',', '.');
  const n = Number(normalized);
  return Number.isFinite(n) ? n : null;
}
